import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { LlmIntegrationHeroSection } from "@/components/insights/llm-integration/LlmIntegrationHeroSection";
import { LlmIntegrationTakeaway } from "@/components/insights/llm-integration/LlmIntegrationTakeaway";
import { LlmIntegrationFounderQuote } from "@/components/insights/llm-integration/LlmIntegrationFounderQuote";
import { LlmIntegrationProviders } from "@/components/insights/llm-integration/LlmIntegrationProviders";
import { LlmIntegrationBestPractices } from "@/components/insights/llm-integration/LlmIntegrationBestPractices";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const LlmIntegrationGuide = () => {
  return (
    <>
      <InsightEngagementTracker slug="llm-integration-guide" title="LLM Integration Guide" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb category="AI Development" currentPage="LLM Integration Guide" />
        <LlmIntegrationHeroSection />
        <AnimatedSection delay={100} className="mt-10 sm:mt-12"><LlmIntegrationTakeaway /></AnimatedSection>
        <AnimatedSection delay={50} className="mt-8 sm:mt-10"><LlmIntegrationFounderQuote /></AnimatedSection>
        <div className="section-divider" />
        <AnimatedSection delay={0}><LlmIntegrationProviders /></AnimatedSection>
        <AnimatedSection delay={0}><LlmIntegrationBestPractices /></AnimatedSection>
        <AnimatedSection delay={0}><InsightBenchmarks insightSlug="llm-integration-guide" /></AnimatedSection>
        <AnimatedSection delay={0}><InsightFAQSection insightSlug="llm-integration-guide" /></AnimatedSection>
        <AnimatedSection delay={0}><RelatedTools insightSlug="llm-integration-guide" /></AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default LlmIntegrationGuide;
